import _ from 'lodash';
import template from './materijal.html';

class MaterijalController {
    constructor() {

    }

    $onInit() {
        this.selectedItem = undefined;

    }

    click(item) {
        if (this.selectedItem === item) {
            this.selectedItem = undefined;
            this.onClick({item: undefined});
        }else{
            this.selectedItem = item;
            this.onClick({item: item});
        }
    }

    itemSelected(item) {
        return this.selectedItem === item;
    }
}

MaterijalController.$inject = [];

const MaterijalComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: MaterijalController,
    controllerAs: 'vm',
    bindings:{
        items: '<',
        onClick: '&'
    }
};

export {MaterijalComponent};
export {MaterijalController};



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/materijal.component.js